import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, DetailsWrapper, MetricTitleSkeleton, TitleSkeleton, SubtitleSkeleton, IconWrapper } from './styles';
export default function ShopperDetailsCardSkeleton(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(DetailsWrapper, null, /*#__PURE__*/React.createElement(MetricTitleSkeleton, {
    width: 90
  }), /*#__PURE__*/React.createElement(TitleSkeleton, {
    width: 110
  }), /*#__PURE__*/React.createElement(SubtitleSkeleton, {
    width: 100
  })), /*#__PURE__*/React.createElement(IconWrapper, null, icon));
}
ShopperDetailsCardSkeleton.propTypes = {
  /**
   * The component to be rendered as the icon.
   */
  icon: PropTypes.element
};